// import dayjs from "dayjs";
// import { createSlice } from "@reduxjs/toolkit";
// import { deleteSale, fetchSalesRecord } from "./SalesRecordThunk";

// const initialState = {
//   list: [],
//   loading: false,
//   accessType: "WRITE", // later could be dynamic
//   filters: {
//     filterType: "All",
//     recordType: "without item",
//     fromDate: null, // 👈 separate field
//     toDate: null,
//   },
// };

// const salesRecordSlice = createSlice({
//   name: "salesRecord",
//   initialState,
//   reducers: {
//     setFilters: (state, action) => {
//       state.filters = { ...state.filters, ...action.payload };
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchSalesRecord.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchSalesRecord.fulfilled, (state, action) => {
//         state.loading = false;
//         state.list = action.payload;
//       })
//       .addCase(fetchSalesRecord.rejected, (state) => {
//         state.loading = false;
//       })
//       .addCase(deleteSale.fulfilled, (state, action) => {
//         // success handled by fetch refresh
//       })
//       .addCase(deleteSale.rejected, (state, action) => {
//         // could show error toast later
//       });

//   },
// });

// export const { setFilters } = salesRecordSlice.actions;
// export default salesRecordSlice.reducer;


// store/sales/SalesRecordSlice.js
// src/pages/SalesRecord/store/SalesRecordSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchSalesRecord, deleteSale } from "./SalesRecordThunk";

export const DEFAULT_SALES_RECORD_COLUMNS = [
  "no",
  "sale_voucher_no",
  "date",
  "acc_name",
  "total_amount",
  "due_total",
  "actions",
];

const getSavedSalesRecordColumns = () => {
  try {
    const saved = sessionStorage.getItem("salesRecordVisibleColumns");
    return saved ? JSON.parse(saved) : DEFAULT_SALES_RECORD_COLUMNS;
  } catch {
    return DEFAULT_SALES_RECORD_COLUMNS;
  }
};

const initialState = {
  list: [], // flat or grouped structure
  details: [], // for recordType === 'with item'
  loading: false,
  error: null,
  printMode: false,
  visibleColumns: getSavedSalesRecordColumns(),
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null,
    toDate: null,
    customerId: null,
    employeeId: null,
    itemId: null,
    groupId: null,
    categoryId: null,
    userId: null,
    locationId: null,
    tag_groupnameid: null,
    tagFeildNameid: null,
    itemSerial: null,
  },
};

const salesRecordSlice = createSlice({
  name: "salesRecord",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = initialState.filters;
    },
    setPrintMode(state, action) {
      state.printMode = action.payload;
    },
    setList(state, action) {
      state.list = action.payload || [];
    },
    setDetails(state, action) {
      state.details = action.payload || [];
    },
    setVisibleColumns(state, action) {
      state.visibleColumns = action.payload;
      sessionStorage.setItem(
        "salesRecordVisibleColumns",
        JSON.stringify(action.payload)
      );
    },
    resetVisibleColumns(state) {
      state.visibleColumns = DEFAULT_SALES_RECORD_COLUMNS;
      sessionStorage.removeItem("salesRecordVisibleColumns");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalesRecord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSalesRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchSalesRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load data";
      })
      .addCase(deleteSale.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSale.fulfilled, (state, action) => {
        const deletedId = action.meta.arg;
        state.list = state.list.filter(r => r.sale_id !== deletedId);
        state.details = state.details.filter(r => r.sale_id !== deletedId);
      })
      .addCase(deleteSale.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setFilters,
  resetFilters,
  setPrintMode,
  setList,
  setDetails,
  setVisibleColumns,
  resetVisibleColumns,
} = salesRecordSlice.actions;
export default salesRecordSlice.reducer;

export const selectSalesList = (state) => state.salesRecord.list;
export const selectSalesDetails = (state) => state.salesRecord.details;
export const selectSalesLoading = (state) => state.salesRecord.loading;
export const selectSalesFilters = (state) => state.salesRecord.filters;
